'use client';
import React, { useRef } from 'react';
import { motion, useScroll, useTransform, useSpring } from 'framer-motion';

export function ParallaxComponent() {
  const containerRef = useRef(null);
  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ['start start', 'end start'],
  });
  // Smooths out the raw scroll signal so layers glide instead of jumping
  // on every scroll-wheel tick — this is what GSAP's scrub:0 + Lenis
  // combo was doing in the original version.
  const smoothProgress = useSpring(scrollYProgress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001,
  });

  // Same yPercent values as the original GSAP layers (1: 70, 2: 55, 3: 40, 4: 10)
  const y1 = useTransform(smoothProgress, [0, 1], ['0%', '70%']);
  const y2 = useTransform(smoothProgress, [0, 1], ['0%', '55%']);
  const y3 = useTransform(smoothProgress, [0, 1], ['0%', '40%']);
  const y4 = useTransform(smoothProgress, [0, 1], ['0%', '10%']);

  return (
    <div className="parallax">
      <section ref={containerRef} className="relative h-[200vh]">
        <div className="sticky top-0 h-screen w-full overflow-hidden bg-black">
          <motion.img
            src="https://cdn.prod.website-files.com/671752cd4027f01b1b8f1c7f/6717795be09b462b2e8ebf71_osmo-parallax-layer-3.webp"
            alt=""
            style={{ y: y1 }}
            className="absolute inset-0 h-full w-full object-cover"
          />
          <motion.img
            src="https://cdn.prod.website-files.com/671752cd4027f01b1b8f1c7f/6717795b4d5ac529e7d3a562_osmo-parallax-layer-2.webp"
            alt=""
            style={{ y: y2 }}
            className="absolute inset-0 h-full w-full object-cover"
          />
          <motion.div
            style={{ y: y3 }}
            className="absolute inset-0 flex items-center justify-center"
          >
            <h2 className="text-white text-[16vw] md:text-[6vw] font-medium tracking-tight leading-none md:whitespace-nowrap">
              Expand Your Horizons
            </h2>
          </motion.div>
          <motion.img
            src="https://cdn.prod.website-files.com/671752cd4027f01b1b8f1c7f/6717795bb5aceca85011ad83_osmo-parallax-layer-1.webp"
            alt=""
            style={{ y: y4 }}
            className="absolute inset-0 h-full w-full object-cover"
          />
        </div>
      </section>
    </div>
  );
}